import { useQuery } from "@apollo/client";

import { EXTRACTED_BILL_OF_LADING } from "./billOfLadingApi";

/**
 * The AI reading of a bill of lading document, for the review grid.
 *
 * Unlike 7C's `useProfileReading`, this never polls: `BillOfLadingReviewDialog`
 * only opens once `DocumentAIAnalyzingDialog` has reported the enrichment job
 * SUCCEEDED, so the candidate already exists by the time this query runs.
 * `refetch` stays available for the grid's `onRetry` path, which re-queues
 * extraction and needs a fresh reading once it finishes.
 *
 * Network-only: a save from another tab or a staff Reopen for review changes the
 * saved manifest's version, and a cached reading would send the old version and have
 * the save refused.
 */
export function useBillOfLadingReading(documentId: string | undefined) {
  const { data, loading, error, refetch } = useQuery(EXTRACTED_BILL_OF_LADING, {
    variables: { documentId: documentId ?? "" },
    skip: !documentId,
    fetchPolicy: "network-only",
  });

  return {
    reading: data?.extractedBillOfLading ?? null,
    loading,
    error,
    refetch,
  };
}
